import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';

// Initialize the exporting and export data modules
exportingInit(Highcharts);
exportDataInit(Highcharts);

const CombinedChart = ({ chartData }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (!chartData) return;

    const transformedProductionData = chartData.map(item => [new Date(item.timestamp).getTime(), item.production]);
    const transformedConsumptionData = chartData.map(item => [new Date(item.timestamp).getTime(), item.consumption]);

    const productionColor = Highcharts.getOptions().colors[0];
    const consumptionColor = Highcharts.getOptions().colors[1];

    setChartOptions({
      chart: {
        zoomType: 'x'
      },
      title: {
        text: null
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Datetime'
        }
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          text: 'Energy (kWh)'
        }
      },
      legend: {
        enabled: true
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, productionColor],
              [1, Highcharts.color(productionColor).setOpacity(0).get('rgba')]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        }
      },
      series: [
        {
          type: 'area',
          name: 'Production',
          data: transformedProductionData,
          color: productionColor,
          showInLegend: true,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.color(productionColor).setOpacity(0.5).get('rgba')],
              [1, Highcharts.color(productionColor).setOpacity(0).get('rgba')]
            ]
          },
        },
        {
          type: 'area',
          name: 'Consumption',
          data: transformedConsumptionData,
          color: consumptionColor,
          showInLegend: true,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.color(consumptionColor).setOpacity(0.5).get('rgba')],
              [1, Highcharts.color(consumptionColor).setOpacity(0).get('rgba')]
            ]
          },
        }
      ],
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      accessibility: {
        enabled: false
      }
    });
  }, [chartData]);

  if (!chartOptions || !chartData) return null;

  return (
    <div style={{ width: '100%', height: '400px' }}>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default CombinedChart;
